import { render, staticRenderFns } from "./ConfirmationDetailsCard.vue?vue&type=template&id=0ddcf846&scoped=true&"
import script from "./ConfirmationDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationDetailsCard.vue?vue&type=style&index=0&id=0ddcf846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcf846",
  null
  
)

export default component.exports